import { Dispatch, useState } from "react";
import axios from 'axios';
import { AppConfigExtended } from "../types";
import { IADPActions } from "../state/Actions";
import { actions } from "../state";
import { usePlatformVersionService } from "./usePlatformVersionsService";
import { environment,getEnvironmnet } from "../util";
import { useDedupEffect } from "../util/useDedupEffect";
const logPrefix = "[ADPClient][ConfigServiceHook]"
export function useConfigService(dispatch:Dispatch<IADPActions>) {
  const [config, setConfig] = useState<AppConfigExtended>();
  const manifest = usePlatformVersionService(dispatch);
  function fetchConfig() {
    console.log(logPrefix,"fetching configuration...");
    axios.get(`${environment.resovleAppDomain()}config/config.json`)
  .then(function (response) {
    console.log(logPrefix,"configuration fetch status", response.status);
    setConfig({...response.data,environment:getEnvironmnet()});
  })
  .catch(function (error) {
    // handle error
    console.log(logPrefix,"error fetching configuration",error);
     dispatch(actions.createSetViewAction("LoadingErrroView"));
  })
  }

  useDedupEffect(() => {
    if (!manifest) {
      return;
    }
    dispatch(actions.createSetReleaseVersionAction(manifest));
    fetchConfig();
  }, [manifest]);

  return config;
}
